import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2, Inject, Optional, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import config from 'config/default.json';

@Component({
  selector: 'app-vca-detail-dep-mod',
  templateUrl: './vca-detail-dep-mod.component.html',
  styleUrls: ['./vca-detail-dep-mod.component.scss']
})
export class VcaDetailDepModComponent implements OnInit{
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private helper: HelperModule,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<VcaDetailDepModComponent>
  ) {}
  @Input() rowInfos: { [x:string]: any } = new Map();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() platformInfos: { [x:string]: any } = new Map();
  @Input() metaData:any = new Map();
  @Input() mergeData:{[x: string]: any}[]= [];
  @Input() manageKey:string = '';
  @Input() action:any;
  @Input() manageKeyValue:any;
  @Input() filterData:any;
  @Output() inProgress = new EventEmitter<any>();
  @Output() updateRow = new EventEmitter<any>();

  formDataAndFiles:any  = new FormData();

  credits: number[] = Array.from({ length: 45 }, (_, i) => i + 1);
  institutionTypes: string[] = ['Institut', 'Ecole', 'Université'];
  structureTypes: string[] = ['Faculté', 'Institut', 'Ecole', 'Centre'];
  departmentTypes: any[] = [{'key': 'academic', 'value': 'Académique'}, {'key': 'entrance_exam', 'value': 'Concours'}];
  moduleTypes = ['Approfondissement', 'Fondamentale', 'Libre', 'Transversale', 'Complémentaire', 'Spécialité', 'Stage'];
  cycles:{[x: string]: any}[]= [];
  semesters:{[x: string]: any}[]= [];
  categories:{[x: string]: any}[]= [];
  selectedRows:{[x: string]: any}[]= [];

  actionControl = new FormControl();
  cycleControl = new FormControl();
  semesterControl = new FormControl();
  nameControl = new FormControl();
  fullNameControl = new FormControl();
  typeControl = new FormControl();
  creditControl = new FormControl();
  moduleCategoryControl = new FormControl();
  aiGereratorPromptControl = new FormControl(); 
  pythonCodeControl = new FormControl(); 

  mergeWithControl = new FormControl();
  parentControl = new FormControl();

  searchMergeWithControl = new FormControl();
  searchParentControl = new FormControl();

  terminalOutput: string = '$'
  scrappingData: { [x:string]: any}[] = [];
  scrappingColumns: string[] = [];
  
  scrappingResultSwitch: 'data' | 'terminal' = 'terminal';

  filteredMergeWith: { [x:string]: string|number|boolean }[] = [];
  filteredParent: { [x:string]: string|number|boolean }[] = [];
  delfaultPrompts:any = {
    vca_institution: '',
    vca_structure: '',
    vca_department: '',
    vca_module: `Extract all modules from every page of this document and return the result as a JSON array of objects.

For each module found, create an object with the following fields:

- semester_full_name: The semester name (e.g. "Semestre 1", "Semestre 2", etc.).
- module_name: The value in the "Code des ECUE" column.
- module_full_name: The value in the "ECUE" column.
- module_credit: The numeric value in the "COEF" column.
- module_type: The category of the module (e.g. "Fondamentale", "Spécialité", "Transversale", etc.).

Rules:
- Extract data from all pages.
- Preserve the exact module full name found in the document.
- Preserve the exact module code and module title.
- Return only valid JSON.
- Do not include explanations, markdown, or additional text.

Expected output format:

[
  {
    "semester_full_name": "Semestre 1",
    "module_name": "MTH 101",
    "module_full_name": "Algorithmique Programmation de Base",
    "module_credit": 4,
    "module_type": "Fondamentale"
  },
  {
    "semester_full_name": "Semestre 4",
    "module_name": "PHY 102",
    "module_full_name": "Physique Générale",
    "module_credit": 3,
    "module_type": "Fondamentale"
  }
]`,
  }
  code = `import requests
from bs4 import BeautifulSoup

url = "https://example.com"
html = requests.get(url).text

print(html[:500])`

  ngOnInit(){
    if (this.data) {
      this.userInfos = this.data.user_infos || {};
      this.rowInfos = this.data.row_infos || {};
      this.platformInfos = this.data.platform_infos || {};
      this.filterData = this.data.filter_data || {};
      this.metaData = this.data.metadata || {};
      this.mergeData = this.data.merge_data || '';
      this.manageKey = this.data.manage_key || '';
      this.manageKeyValue = this.data.manage_key_value || {};
      this.selectedRows = this.data.selected_rows || [];
      this.action = this.data.action || '';
      this.aiGereratorPromptControl.setValue(this.delfaultPrompts[this.manageKey]);
    }
    
    if(!['add_new', 'import_object','delete_object', 'build_learning_content'].includes(this.action)) this.mergeData = this.mergeData.filter((element:any)=> element.id > 0 && element.id != this.rowInfos['id']);
    this.actionControl.setValue(this.action);
    this.parentControl.setValue(this.rowInfos['id_parent']);
    this.cycleControl.setValue(this.rowInfos['id_cycle']);
    this.semesterControl.setValue(this.rowInfos['id_semester']);
    this.nameControl.setValue(this.rowInfos['name']);
    this.fullNameControl.setValue(this.rowInfos['full_name']);
    this.typeControl.setValue(this.rowInfos['type']);
    this.creditControl.setValue(this.rowInfos['credit']);
    this.moduleCategoryControl.setValue(this.rowInfos['id_category_module']);
    this.filteredParent = this.metaData?.parent ?? [];
    this.filteredMergeWith = this.mergeData;
    this.cycles = this.metaData.cycle ?? [];
    this.semesters = this.metaData.semester ?? [];
    this.categories = this.metaData.category ?? [];

    this.applySearch();
    this.cdRef.detectChanges();
    
      
  }

  applySearch(){
    this.searchMergeWithControl.valueChanges.subscribe((text) => {
      return this.filteredMergeWith = this.mergeData.filter((element:any) => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchParentControl.valueChanges.subscribe((text) => {
      return this.filteredParent = this.metaData.parent.filter((element:any) => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
  }
  selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
    return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
  }
  normalizeString(str:any){
    return str.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }
  verifyAndUpload(){
    
    if(['delete_object', 'import_object', 'build_learning_content'].includes(this.action)){
      if(this.actionControl.value == null)
        this.helper.showToast('Action is not defined...');
      else{
        this.applyUpdate();
      } 
      return;
    }else{
      if(this.manageKey == 'vca_institution' && this.parentControl.value == null){
        this.helper.showToast('Country is not defined...');
        return;
      }
      if(this.manageKey == 'vca_structure' && this.parentControl.value == null){
        this.helper.showToast('Institution is not defined...');
        return;
      }
      if(this.manageKey == 'vca_department' && this.parentControl.value == null){
        this.helper.showToast('Structure is not defined...');
        return;
      }
      if(this.manageKey == 'vca_module' && this.parentControl.value == null){
        this.helper.showToast('Deartment is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && this.manageKey == 'vca_module' && this.semesterControl.value == null){
        this.helper.showToast('Semester is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && this.manageKey == 'vca_module' && this.creditControl.value == null){
        this.helper.showToast('Credit is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && this.manageKey == 'vca_department' && this.cycleControl.value == null){
        this.helper.showToast('Cycle is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && this.nameControl.value == null){
        this.helper.showToast('Name is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && this.fullNameControl.value == null){
        this.helper.showToast('Full Name is not defined...');
        return;
      }
      if(!['delete_object', 'ai_parse_metadata', 'object_scrapping'].includes(this.action) && ['vca_structure', 'vca_module'].includes(this.manageKey) && this.typeControl.value == null){
        this.helper.showToast('Type is not defined...');
        return;
      }
      if(this.action == 'merge_with' && this.mergeWithControl.value == null){
        this.helper.showToast('No merge element selected...');
        return;
      }
      if(['update'].includes(this.action) && this.manageKey == 'vca_module' && this.filterData.key == 'department'){
        this.helper.showToast('Updated can happen only in structure...');
        return;
      }
      this.applyUpdate();
    }
  }
  applyUpdate(){
    let action = this.actionControl.value;
    let mergeDate = this.mergeWithControl?.value?.length? this.mergeData.filter((element:any)=> this.mergeWithControl.value.includes(element.id)): [];
    let rowInfos = {
      id: parseInt(this.rowInfos['id']),
      id_country: this.manageKey == 'vca_institution'? this.parentControl.value: parseInt(this.rowInfos['id_country']),
      id_vca_institution: this.manageKey == 'vca_structure'? this.parentControl.value: parseInt(this.rowInfos['id_vca_institution']),
      id_structure: this.manageKey == 'vca_department'? this.parentControl.value: parseInt(this.rowInfos['id_structure']),
      id_cycle: this.manageKey == 'vca_department'? this.cycleControl.value: null,
      cycle_name: this.manageKey == 'vca_department'? this.cycles.find((element:any) => element.id == this.cycleControl.value)?.['name']: null,
      id_department: this.manageKey == 'vca_module'? this.parentControl.value: parseInt(this.rowInfos['id_department']),
      id_semester: this.manageKey == 'vca_module'? this.semesterControl.value: null,
      name: this.nameControl.value,
      full_name: this.fullNameControl.value,
      type: this.typeControl.value,
      credit: this.creditControl.value,
      id_category_module: this.moduleCategoryControl.value,
      table_label: this.manageKeyValue?.[this.manageKey]?.element ?? 'Element',
      object_key: this.rowInfos['object_key']
    };
    let selectedRows = ['delete_object', 'build_learning_content'].includes(this.action)? this.selectedRows.map((element: any) => {
        return {
          id: element.id,
          nb_structure: element.nb_structure,
          nb_department: element.nb_department,
          nb_module: element.nb_module,
          nb_student: element.nb_student,
          nb_content: element.nb_content,
          nb_proj_content: element.nb_proj_content
        };
      }): this.selectedRows;
      let data = {
        row_infos: rowInfos, 
        manage_key: this.manageKey, 
        action: this.actionControl.value, 
        selected_objects: selectedRows, 
        merge_with: mergeDate,
        ai_generate_prompt: this.aiGereratorPromptControl.value,
        metadata: this.scrappingData,
        platform_infos: this.platformInfos,
        user_infos: this.userInfos
      }

      this.inProgress.emit(true);
      if(action == 'ai_parse_metadata'){
        if(this.formDataAndFiles.getAll('file').length){
          this.formDataAndFiles.delete('data');
          this.formDataAndFiles.append('data', JSON.stringify(data));
          this.helper.showToast('Job started...');
          this.apiService.uploadDataAndFile(config.master.ndapi.url +'/virtualcampus/web/vca-department-module/ai_parse_metadata', this.formDataAndFiles, this.userInfos['access_token']).subscribe((response:any)=>{
            this.helper.showToast(response.message);
            this.inProgress.emit(false);
             this.onClose();
          });
        }else this.helper.showToast('No file selected...');
      }else if (action == 'object_scrapping') this.uploadScrapedData(data);
      else
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/web/vca-department-module/apply-object', data, this.userInfos['access_token']).subscribe((response:any)=>{
        this.helper.showToast(response.message);
        this.inProgress.emit(false);
        this.onClose();
      });
  }
  runSaveScrappingData(mode:string){
    let data = {
      id_vca_institution: this.parentControl.value,
      scrapping_code: this.pythonCodeControl.value
    }
    if(mode == 'save'){
      if(this.parentControl.value != null && this.pythonCodeControl.value != null){
        this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/web/vca-department-module/save-scrapping-code', data, this.userInfos['access_token']).subscribe((response:any)=>{
          this.helper.showToast(response.message);
          this.inProgress.emit(false);
        });
      }else this.helper.showToast('Institution or Scrapping Code empty...');
    }
    if(mode == 'run'){
      if(this.pythonCodeControl.value != null){
        this.apiService.queryData(config.master.flapi.url + '/enovsky/run_scraper', data, this.userInfos['access_token']).subscribe((response:any)=>{
          this.scrappingData = response.data;
          if (this.scrappingData.length) this.scrappingColumns = Object.keys(this.scrappingData[0] || {});
          this.terminalOutput = response.logs;
          this.inProgress.emit(false);
        });
      }else this.helper.showToast('Scrapping Code empty...');
    }
  }
  uploadScrapedData(data:any){
    if(this.scrappingData.length == 0 || this.parentControl.value == null){
      this.helper.showToast('Institution not defined or No Data to upload...');
      return;
    }else{
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '50%',
        position: {top: '30px' },
        data: {page: 'confirmation', text: 'This will upload the scraped data... Continue ?'}
      });
      dialogRef.afterClosed().subscribe((toContinue:boolean) => {
        if(toContinue){
          this.inProgress.emit(true);
          
          this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/web/vca-department-module/upload-scrapped-data', data, this.userInfos['access_token']).subscribe((response:any)=>{
            this.inProgress.emit(false);
            this.helper.showToast(response.message);
          })
        }
      })
    }
    
  }
  setScrappingCode(){
    this.pythonCodeControl.setValue(this.metaData.parent.find((element:any)=> element.id == this.parentControl.value)?.scrapping_code);
  }
  
  onFileSelected(event:any){
    let files = event.target.files;
    for(var i = 0; i < files.length; i++) this.formDataAndFiles.append("file", files[i]);
  }
  updateDetails(){
    this.action = this.actionControl.value;
  }
  onClose(){
    if (['add_new', 'import_object', 'delete_object', 'build_learning_content', 'ai_parse_metadata'].includes(this.action)) 
      this.dialogRef.close(false);
  }
}
